import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppSelectorService } from 'src/app/shared/services/app-selector/app-selector.service';
import { environment } from 'src/environments/environment.hmr';

const CE_DATA = "CE_DATA";

@Component({
  selector: 'app-redirect-to-ce',
  templateUrl: './redirect-to-ce.component.html',
  styleUrls: ['./redirect-to-ce.component.scss']
})
export class redirectToCeComponent implements OnInit {

  shouldShowLoader: boolean = true;
  inlineLoader: boolean = true;
  constructor(
    private router: Router,
    private appSelectorService: AppSelectorService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(queryParams => {
      if (queryParams && queryParams.msg) {
        let message = atob(queryParams.msg);
        this.shouldShowLoader = false;
        this.appSelectorService.removeCEDataFromLocalStorage();

        if (!message.toLowerCase().includes("went wrong")) {
          this.router.navigate(['ce-request-access']);
        }
      }
    })

    window.addEventListener("message", (event) => {
      if (event.data && event.data.hasOwnProperty("is_error") && (event.origin.includes("hansel.io") || event.origin.includes("netcorecloud.com"))) {
        this.redirectCEPanel(event.data);
      }
    });
  }

  redirectCEPanel(resp) {
    if (resp.is_error || !Object.keys(resp.api_response).length) {
      this.shouldShowLoader = false;
      let errorType = resp.error_type;
      if (errorType === "USER_DOES_NOT_EXIST") {
        this.router.navigate(['ce-request-access']);
      }
      return;
    }

    let data = resp.api_response;
    let rt_url = btoa(environment.returnURL);
    let rd_url = "";

    let ce_url: string = `https://${data.server}.netcoresmartech.com/${data.panel_name}/admin/index.php/login/switch_account_login_v2`;
    
    if (resp.redirectPage === "switch-panel") {
      rd_url = data.home_dashboard_url;
    } else if (resp.redirectPage === "create-segment") {
      rd_url = data.create_segment_url;
    } else if (resp.redirectPage === "create-list") {
      rd_url = data.create_list_url;
    } else if (resp.redirectPage === "edit-segment") {
      if (parseInt(data.ia2) === 1) {
        rd_url = `${data.edit_segment_url}${resp.segmentId.split("s_")[1]}`;
      } else {
        rd_url = data.edit_segment_url;
      }
    } else if (resp.redirectPage === "edit-list") {
      if (parseInt(data.ia2) === 1) {
        rd_url = `${data.edit_list_url}${resp.segmentId.split("l_")[1]}`;
      } else {
        rd_url = data.edit_list_url;
      }
    } else {
      rd_url = data.home_dashboard_url;
    }

    let baseUrl = `https://${data.server}.netcoresmartech.com/${data.panel_name}/`;

    let postData = {
      uuid: data.uuid,
      rt_url,
      rd_url: btoa(rd_url)
    }

    this.appSelectorService.postFormDataAndRedirect(ce_url, postData);

    let storageData = {
      timeStamp: Date.now() + 4 * 60 * 60 * 1000,
      postData,
      create_list_url: data.create_list_url,
      create_segment_url: data.create_segment_url,
      edit_list_url: data.edit_list_url,
      edit_segment_url: data.edit_segment_url,
      home_dashboard_url: data.home_dashboard_url,
      ia2: parseInt(data.ia2),
      baseUrl
    }

    localStorage.setItem(CE_DATA, JSON.stringify(storageData));
  }

}
